import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component('forecastBase', {
        template: require('./forecastBaseComponent.html'),
        bindings: {
            parameters: '<',
            stepEnter: "=",
            market: "=",
            forecast: "=",
            historicalDataCallback: "&",
            isEditable: "<",
            skuId: "<",
            isSku: "<",
            isRf: '<',
            additionalTabs: '<',
            onPriceChangeInYearsChanged: '&',
            additionalForecastCorrectionAboutFacts: '<',
            additionalForecastCorrectionAboutFactsTranslationKey: '@',
            freezedMonthsEnabled: '@',
            getFreezedMonths: '&',
            historicalDataTabButtonKey: '@',
            historicalDataTab: '@',
            freezedMonthsTranslationKey: "@"
        },
        controller: ['$scope', 'ChartsConfig', 'dtpChartService', angularServicesNames.$translate, 'debounce', 'freezedMonthsService',
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                ChartsConfig: $TSFixMe,
                dtpChartService: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                debounce: $TSFixMe,
                freezedMonthsService: $TSFixMe
            ) {
                const $ctrl = this;
                $ctrl.commonHelper = {
                    showValueButton: true,
                    gridValue: false,
                    hideHistoricalDataTable: true,
                    hideHistoricalDataTableBtn: true,
                    deviationImsFromRF: false
                };
                $ctrl.showInMilions = false;

                $scope.$on('LanguageChanged', () => resetChartTranslations());
                resetChartTranslations();

                function resetChartTranslations() {
                    $translate(['CHART_SERIES.HISTORICAL', 'CHART_SERIES.AFTER_CORRECT']).then(function (translations: $TSFixMe) {
                        $ctrl.historicalSeries = translations["CHART_SERIES.HISTORICAL"];
                        $ctrl.correctSeries = translations["CHART_SERIES.AFTER_CORRECT"];
                        $ctrl.series = [$ctrl.historicalSeries, $ctrl.correctSeries];
                    });
                }

                $ctrl.datasetOverride = ChartsConfig.datasetOverride;

                $ctrl.options = ChartsConfig.options;
                $ctrl.tabsCorrect = {};
                $ctrl.tabsCorrectAboutFacts = {};
                $ctrl.tabsMathModel = {};

                $scope.actionsInData = {
                    skipPeriods: function () {
                        $ctrl.tabsCorrect.enter();
                    },
                    forecastingModel: function () {
                        $ctrl.tabsMathModel.enter();
                    },
                    factsCorrect: function () {
                        $ctrl.tabsCorrectAboutFacts.enter();
                    },
                    valueToVolume: function () {
                        $ctrl.volumeToValueSelected();
                    }
                };

                $ctrl.freezedMonthsChanged = () => {
                    if ($ctrl.freezedMonthsEnabled) {
                        $ctrl.freezedMonthPromise = $ctrl.getFreezedMonths({
                            freezedMonths: $ctrl.forecast.freezedMonths
                        }).then((freezedMonthVolume: $TSFixMe) => {
                            $ctrl.forecast.freezedMonthsVolume = freezedMonthVolume;
                            freezedMonthsService.recalculateFreezedMonth($ctrl.forecast, $ctrl.parameters);
                        });
                    }
                }

                $scope.$watchGroup(['$ctrl.forecast.historicalData', '$ctrl.forecast.dataAfterCorrection'], debounce(function () {
                    if (!$ctrl.forecast)
                        return;

                    $ctrl.dataToChart = [
                        $ctrl.forecast.historicalData,
                        $ctrl.forecast.dataAfterCorrection
                    ];
                }, 300));

                $ctrl.isMarketForecast = function () {

                    return $ctrl.market && angular.equals($ctrl.forecast, $ctrl.market.forecast);
                };

                $ctrl.$onInit = function () {
                    $scope.labels = dtpChartService.preparePeriodsAndLabels($ctrl.parameters.historicalDataStart, $ctrl.parameters.historicalDataEnd).periods;
                    $ctrl.stepEnter = function () {
                        $ctrl.activeTab = 0;
                    };


                    if (angular.isUndefinedOrNull($ctrl.historicalDataTabButtonKey)) {
                        $ctrl.historicalDataTabButtonKey = 'COMMON.SHOW_VALUES';
                    }

                    if (angular.isUndefinedOrNull($ctrl.historicalDataTab)) {
                        $ctrl.historicalDataTab = 'forecastBaseDefaultHistoryValues.html';
                    }

                    if (angular.isUndefinedOrNull($ctrl.freezedMonthsTranslationKey)) {
                        $ctrl.freezedMonthsTranslationKey = 'FORECAST.CORRECTION_ABOUT_FACTS.FREEZE_MONTHS';
                    }
                };
            }
        ]
    })

})(angular.module('topline.modules'));